import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import "./UserDataDeletion.css";

const UserDataDeletion = () => {
  useEffect(() => {
    // Scroll to the top when navigating to this page
    window.scrollTo(0, 0);
    document.title = "User Data Deletion | Chauwk";
  }, []);

  return (
    <>
      <div className="data-deletion-container">
        {/* Hero Header */}
        <header className="data-deletion-hero">
          <span className="data-deletion-badge">Data Privacy &amp; Compliance</span>
          <h1>USER DATA DELETION</h1>
          <p className="data-deletion-subtitle">
            User Data Deletion Instructions
          </p>
          <div className="data-deletion-divider" />
        </header>

        {/* Content Wrapper */}
        <main className="data-deletion-content-wrapper">
          {/* Intro Card */}
          <section className="data-deletion-intro-card">
            <h2>User Data Deletion Instructions</h2>
            <p>
              Chauwk, operated by Varin Communications Private Limited, respects your
              privacy and provides a way to request the deletion of personal information
              associated with our services, including our WhatsApp Business integration.
            </p>
          </section>

          {/* Detailed Sections List */}
          <div className="data-deletion-sections-list">
            {/* Section 1 */}
            <article className="data-deletion-card">
              <div className="data-deletion-card-header">
                <span className="data-deletion-icon-badge">1</span>
                <h3 className="data-deletion-card-title">
                  How to Request Data Deletion
                </h3>
              </div>
              <div className="data-deletion-card-body">
                <p>
                  To request the deletion of your personal information, Chauwk account
                  data, or information associated with a WhatsApp Business integration,
                  email{" "}
                  <a
                    href="mailto:support@chauwk.com"
                    style={{ color: "#0284c7", fontWeight: 600, textDecoration: "underline" }}
                  >
                    support@chauwk.com
                  </a>{" "}
                  from your registered email address.
                </p>
                <p style={{ fontWeight: 600, color: "#0f172a", marginBottom: "8px" }}>
                  Please include:
                </p>
                <ul className="data-deletion-checklist">
                  <li>
                    <span className="data-deletion-bullet">●</span>
                    <span>Your name and registered email address.</span>
                  </li>
                  <li>
                    <span className="data-deletion-bullet">●</span>
                    <span>Your business name, if applicable.</span>
                  </li>
                  <li>
                    <span className="data-deletion-bullet">●</span>
                    <span>A description of the account or data you want deleted.</span>
                  </li>
                </ul>
                <div className="data-deletion-note">
                  🔒 <strong>Verification Note:</strong> For security, we may request
                  additional information to verify your identity or authority to make the
                  request.
                </div>
              </div>
            </article>

            {/* Section 2 */}
            <article className="data-deletion-card">
              <div className="data-deletion-card-header">
                <span className="data-deletion-icon-badge">2</span>
                <h3 className="data-deletion-card-title">What Data Can Be Deleted?</h3>
              </div>
              <div className="data-deletion-card-body">
                <p>
                  Depending on your request and the services you use, deletion may
                  include account information, connected WhatsApp account details,
                  message records, and other personal information stored by Chauwk.
                </p>
                <p>
                  Certain information may be retained where required by applicable law,
                  for legitimate security purposes, or to resolve disputes.
                </p>
              </div>
            </article>

            {/* Section 3 */}
            <article className="data-deletion-card">
              <div className="data-deletion-card-header">
                <span className="data-deletion-icon-badge">3</span>
                <h3 className="data-deletion-card-title">
                  WhatsApp Business Account Disconnection
                </h3>
              </div>
              <div className="data-deletion-card-body">
                <p>
                  If you are a business using Chauwk's WhatsApp integration, you may
                  request that your connected WhatsApp Business Account be disconnected
                  from Chauwk.
                </p>
                <p>
                  Disconnecting your account from Chauwk does not automatically delete
                  information held independently by Meta, WhatsApp, or the business you
                  communicated with. You may need to contact those parties separately.
                </p>
              </div>
            </article>

            {/* Section 4 */}
            <article className="data-deletion-card">
              <div className="data-deletion-card-header">
                <span className="data-deletion-icon-badge">4</span>
                <h3 className="data-deletion-card-title">Processing Your Request</h3>
              </div>
              <div className="data-deletion-card-body">
                <p>
                  We will verify and process deletion requests in accordance with
                  applicable law and our Privacy Policy. We will communicate with you if
                  additional information is required.
                </p>
              </div>
            </article>
          </div>

          {/* Contact Details Card */}
          <section className="data-deletion-contact-card">
            <h3>Contact Us</h3>
            <p style={{ margin: "0 0 12px", color: "#475569" }}>
              For data deletion requests or questions, contact:
            </p>
            <div className="data-deletion-contact-info">
              <div className="data-deletion-contact-item">
                <strong>Email:</strong>{" "}
                <a href="mailto:support@chauwk.com">support@chauwk.com</a>
              </div>
              <div className="data-deletion-contact-item">
                <strong>Company:</strong> Varin Communications Private Limited
              </div>
              <div className="data-deletion-contact-item">
                <strong>Privacy Policy:</strong>{" "}
                <Link to="/privacy-policy">https://www.chauwk.com/privacy-policy</Link>
              </div>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default UserDataDeletion;
